var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.fullName)}}),_vm._v(" "),_c('v-list-item-subtitle',{staticClass:"font-weight-bold",class:_vm.colorText,domProps:{"textContent":_vm._s(_vm.text)}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }